import captions from './captions.json';
import { safeBrowserLinks } from '../services/api/ApiConstants';

let FALLBACK_LANGUAGE;

if (window.marketplaceName.includes('fjord') || window.marketplaceName.includes('ielts')) {
    FALLBACK_LANGUAGE = 'en_gb_fjord';
} else {
    FALLBACK_LANGUAGE = 'en_us';
}

const FALLBACK_PLAYER_READY_WAIT_TIME = 60;

const locale = localStorage.getItem('locale');
const translate = FALLBACK_LANGUAGE === 'en_gb_fjord' ? captions.en_gb_fjord : captions[locale] || captions.en_us;
let loaderTimeoutId;

const runLoadTimer = () => {
    window.testPlayerLoadStart = new Date().getTime();
    window.testPlayerReady = false;
    const waitTime = parseInt(window.marketplaceProperties && window.marketplaceProperties.PLAYER_READY_WAIT_TIME_SECONDS, 10)
        || FALLBACK_PLAYER_READY_WAIT_TIME; // seconds

    loaderTimeoutId = setTimeout(() => {
        if (window.testPlayerReady === false) {
            showFailMessage();
        }
    }, waitTime * 1000);
};

const showLoadingMessage = () => {
    if (window.location.search.indexOf('context=exam') === -1) {
        return;
    }

    const container = document.getElementById('loader-message-container');
    if (container) {
        container.innerHTML = `
            <h2>${translate.begin}</h2>
            <div>${translate.wait}</div>
        `;
    }
};

const showFailMessage = () => {
    if (loaderTimeoutId) {
        clearTimeout(loaderTimeoutId);
    }

    const container = document.getElementById('loader-container');
    if (container) {
        const { assessmentRunId } = window.playerStartupConfig;
        const isSeb = window.navigator.userAgent.indexOf('SEB') > -1;
        const isIEP = window.navigator.userAgent.indexOf('IEP') > -1;
        // TODO: add chrome app support
        let href;
        if (isSeb || isIEP) {
            href = safeBrowserLinks.QUIT;
        } else {
            href = assessmentRunId > 0 ? `/student#list/${assessmentRunId}` : '/student';
        }

        container.innerHTML = `
            <h2 class='error-message'>${translate.failed}</h2>
            <div>${translate.again}</div>
            <div>${translate.support}</div>
            <a href='${href}'>${translate.exit}</a>
        `;
    } else if (confirm(translate.reload_confirmation)) {
        location.reload();
    }
};

const loadingMessageManager = {
    init() {
        showLoadingMessage();
        runLoadTimer();
    },
    showFailMessage,
};

export default loadingMessageManager;
